import { styled } from "@material-ui/core/styles";

const TagsContainer = styled("div")(
  ({ theme }: { theme: CustomTheme.RootObject }) => ({
    display: "inline-block",
    lineHeight: 0,
    margin: `-${theme.spacing(1) / 2}px`,
    "& > *": {
      margin: `${theme.spacing(1) / 2}px`,
    },
  })
);

export default TagsContainer;
